import _extends from "@babel/runtime/helpers/extends";
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { usePaddingClasses } from "../shared-classes";
import { jsx as _jsx } from "react/jsx-runtime";
export var Image = _ref => {
  var {
    aspect,
    fit = "cover",
    width,
    image,
    padding,
    className,
    style,
    max_height,
    max_width
  } = _ref;
  var classes = useImageClass({
    aspect,
    fit,
    width,
    max_height,
    max_width
  });
  var p = usePaddingClasses(padding);

  if (!image.filename.includes("storyblok")) {
    return /*#__PURE__*/_jsx("img", {
      src: image.filename,
      className: clsx(classes, p, className),
      alt: image == null ? void 0 : image.alt,
      style: _extends({}, style, max_width && {
        maxWidth: max_width + "px"
      }, max_height && {
        maxHeight: max_height + "px"
      })
    });
  }

  var fileDetails = image.filename.replace("https://a.storyblok.com/", "").split("/");
  var [imgWidth] = fileDetails[2].split("x");
  var src = image.filename + "/m/";

  if (max_width && max_width < imgWidth) {
    imgWidth = max_width;
    src = "" + src + max_width + "x0";
  }

  var breakpoints = [640, 768, 1024, 1280, 1536];
  var fileSizes = [];
  var sizes = []; //for each breakpoint create a storyblok img link with a width equal to the maximum screen size of the breakpoint

  breakpoints.forEach(breakpoint => {
    //only reduce image size do not make it larger
    if (isNaN(+imgWidth) || breakpoint >= +imgWidth) return;
    fileSizes.push(image.filename + "/m/" + breakpoint + "x0 " + breakpoint + "w");
    sizes.push("(max-width:" + breakpoint + "px) " + breakpoint + "px");
  });
  fileSizes.push(src + " " + imgWidth + "w");
  sizes.push(imgWidth + "px");
  return /*#__PURE__*/_jsx("img", _extends({
    src: src,
    className: clsx(classes, p, className),
    alt: image == null ? void 0 : image.alt
  }, fileSizes.length > 1 && {
    srcSet: fileSizes.join(","),
    sizes: sizes.join(",")
  }, {
    style: _extends({}, style, max_width && {
      maxWidth: max_width + "px"
    }, max_height && {
      maxHeight: max_height + "px"
    })
  }));
};
var useImageClass = createMemoClass(props => {
  var widths = {
    "1/2": "w-1/2",
    "1/3": "w-1/3",
    "2/3": "w-2/3",
    "1/4": "w-1/4",
    "2/4": "w-2/4",
    "3/4": "w-3/4",
    "1/5": "w-1/5",
    "2/5": "w-2/5",
    "3/5": "w-3/5",
    "4/5": "w-4/5",
    "1/6": "w-1/6",
    "2/6": "w-2/6",
    "3/6": "w-3/6",
    "4/6": "w-4/6",
    "5/6": "w-5/6",
    xs: "max-w-xs"
    /* 320px */
    ,
    sm: "max-w-sm"
    /* 384px */
    ,
    md: "max-w-md"
    /* 448px */
    ,
    lg: "max-w-lg"
    /* 512px */
    ,
    xl: "max-w-xl"
    /* 576px */
    ,
    "2xl": "max-w-2xl"
    /* 672px */
    ,
    "3xl": "max-w-3xl"
    /* 768px */
    ,
    "4xl": "max-w-4xl"
    /* 896px */
    ,
    "5xl": "max-w-5xl"
    /* 1024px */
    ,
    "6xl": "max-w-6xl"
    /* 1152px */
    ,
    "7xl": "max-w-7xl"
    /* 1280px */
    ,
    full: "max-w-full",
    min: "max-w-min",
    max: "max-w-max",
    fit: "max-w-fit"
  };
  var aspects = {
    square: "image-square",
    portrait: "image-portrait",
    landscape: "image-landscape",
    wide: "image-wide"
  };
  var fits = {
    cover: "object-cover",
    contain: "object-contain"
  };
  var classes = clsx("image", widths[props.width], aspects[props.aspect], fits[props.fit]);
  return classes;
});
//# sourceMappingURL=image.js.map